// Human labels + colors for this business's custom order workflow (pcrm_order_status),
// matching src/Order.css and src/components/utils/OrderStatus.js exactly. The backend's
// "effective status" is this value when set, falling back to WooCommerce's native status
// (cancelled/failed/completed/etc.) only when no custom status has been recorded — so both
// vocabularies can appear in analytics responses.
export const ORDER_STATUS_LABELS = {
  pending: "Pending",
  processing: "Processing",
  cancelled: "Cancelled",
  "payment-pending": "Payment Pending",
  "on-hold": "On-hold",
  "mockup-sent": "Mockup Sent",
  "artwrok-missing": "Artwork Missing",
  "mockup-approved": "Mockup Approved",
  sendtoprint: "Send To Print",
  refund: "Refunded",
  refunded: "Refunded",
  "onhold-checknotes": "On-hold Check Notes",
  "job-printed": "Job Printed",
  "changes-required": "Changes Required",
  dispatch: "Dispatch",
  failed: "Failed",
  completed: "Completed",
};

export const ORDER_STATUS_COLORS = {
  pending: "#ef6c9c",
  processing: "#5b841b",
  cancelled: "#eb0303",
  "payment-pending": "#5f77eb",
  "on-hold": "#e1960e",
  "mockup-sent": "#39bf49",
  "artwrok-missing": "#9b5b4d",
  "mockup-approved": "#13859c",
  sendtoprint: "#2a2929",
  refund: "#7a0312",
  refunded: "#7a0312",
  "onhold-checknotes": "#151f9a",
  "job-printed": "#096ed7",
  "changes-required": "#b1018f",
  dispatch: "#607d8b",
  failed: "#616161",
  completed: "#2271b1",
};

const FALLBACK_COLORS = ["#2271b1", "#5b841b", "#94660c", "#c0392b", "#8e44ad", "#16a085", "#e67e22", "#34495e"];

export const formatStatusLabel = (slug) => ORDER_STATUS_LABELS[slug] || slug;

export const getStatusColor = (slug, index = 0) =>
  ORDER_STATUS_COLORS[slug] || FALLBACK_COLORS[index % FALLBACK_COLORS.length];
